import * as React from "react";
const SvgFiRrMakeupBrush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-makeup-brush_svg__a)">
      <path
        fill="#062147"
        d="M23.229.77a2.637 2.637 0 0 0-3.591-.12L5.472 13.134C3.137 13.573 0 14.873 0 17.6A6.407 6.407 0 0 0 6.4 24c2.725 0 4.027-3.136 4.467-5.471L23.352 4.358A2.634 2.634 0 0 0 23.229.77M10.141 16.328l-2.468-2.468 2.005-1.767 2.23 2.23zM6.4 22A4.405 4.405 0 0 1 2 17.6c0-1.508 2.639-2.287 4.049-2.537l2.888 2.887C8.686 19.36 7.908 22 6.4 22M21.849 3.04l-8.616 9.778-2.052-2.051 9.775-8.613a.631.631 0 0 1 .893.886"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-makeup-brush_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMakeupBrush;
